module.exports = __webpack_public_path__ + "img/image--309.64993bca.png";